var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('perfect-solution-description'),_c('appointment-form'),_c('service-card-preview'),_c('digital-workflow'),_c('service-swiper'),_c('accomodation'),_c('testimonials')],1)}
var staticRenderFns = []

export { render, staticRenderFns }